import React from 'react';

import IconLucideBell from '@repo/ui-icons/IconLucideBell';
import { Button } from '@repo/ui-kit/components/core/Button';

import { getSectionIcon } from '../iconUtils';

import { CTAWrapper } from './styles';
import { CTAProps } from './types';

const CTA: React.FC<CTAProps> = ({ isLoading, label, icon, disabled }) => {
  const Icon = icon ? getSectionIcon(icon, IconLucideBell)! : undefined;

  return (
    <CTAWrapper>
      <Button
        ariaLabel={label}
        disabled={disabled}
        isLoading={isLoading}
        leftIcon={Icon}
        name="ctaSubmitButton"
        type="submit"
        width="100%"
      >
        <Button.Label>{label}</Button.Label>
      </Button>
    </CTAWrapper>
  );
};

export default CTA;
